import gql from 'graphql-tag';

export default gql`
  mutation RemoveTestMutation($request: HashimotoTestRemoveInputType!) {
    hashimoto {
      hashimotoTestRemove(testRemoveData: $request) {
        __typename
        ... on BasicMutationSuccess {
          successCode: code
        }
        ... on UnauthorizedException {
          unauthorizedCode: code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
